"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TITLE_KEY_MAP = exports.DEFAULT_INCLUSIONS = void 0;
var TripVersion_1 = require("../models/TripVersion");
var TRIP_INCLUSION_NONE = TripVersion_1.InclusionStatus.None;
exports.DEFAULT_INCLUSIONS = [
    {
        title: 'All meals',
        description: 'All meals are provided as part of the tour package, which may include breakfast, lunch, or dinner on all days.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Transfers',
        description: 'Transportation between different destinations as part of the itinerary.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Alcoholic beverages',
        description: 'Costs for any alcoholic drinks consumed during the trip.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Flights',
        description: 'All the flight charges required for your adventure.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Gratuities',
        description: 'All the guide gratuities throughout your adventure.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Accommodation',
        description: 'Lodging at various hotels, guesthouses, or other types of accommodation during the trip.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Admission fees',
        description: 'Entry fees for museums, parks, historical sites, and other attractions included in the trip.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Porter',
        description: 'Services of a porter to help carry luggage at various points during the trek, or on the mountain.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Visas',
        description: 'Required Visa fees for your travel.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Travel insurance',
        description: 'Travel insurance from a trusted provider for your adventure.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Personal gear',
        description: 'All the personal gear required for your adventure.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Guide fees',
        description: 'Fees for a Guide required for your adventure.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Luggage transfers',
        description: 'Cost for transferring your luggage.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Airport transfer',
        description: 'Transportation from and to Airport',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'International flights',
        description: 'Flights outside the country that are necessary to reach different destinations on the itinerary.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Domestic flights',
        description: 'Flights within the country that are necessary to reach different destinations on the itinerary.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Local guide',
        description: 'A knowledgeable guide to provide insights and information about the places visited.',
        status: TRIP_INCLUSION_NONE,
    },
    {
        title: 'Some meals',
        description: 'Selected meals provided as part of the tour package, which may include breakfast, lunch, or dinner on certain days, as specified in the itinerary.',
        status: TRIP_INCLUSION_NONE,
    },
];
exports.TITLE_KEY_MAP = {
    Accommodation: 'accommodationIncluded',
    'Alcoholic beverages': 'alcoholIncluded',
    'Admission fees': 'admissionFeesIncluded',
    'All meals': 'allMealsIncluded',
    Flights: 'flightsIncluded',
    Gratuities: 'gratuitiesIncluded',
    'Guide fees': 'guideFeesIncluded',
    'Luggage transfers': 'luggageTransfersIncluded',
    'Personal gear': 'personalGearIncluded',
    Porter: 'porterIncluded',
    Transfers: 'transfersIncluded',
    'Travel insurance': 'travelInsuranceIncluded',
    Visas: 'visasIncluded',
    'Airport transfer': 'airportTransfer',
    'International flights': 'internationalFlights',
    'Domestic flights': 'domesticFlights',
    'Local guide': 'localGuide',
    'Some meals': 'someMeals',
};
//# sourceMappingURL=Consts.js.map